import { Controller } from "web-ui/controller"
import * as Log from "web-ui/log"

// Connects to data-controller="option-group"
export default class extends Controller {
  static targets = [
    "option"
  ]

  static events = {
    "change [data-option-group-target~='option']": "onChange"
  }

  connect() {
    this.debug("Connect")
  }

  disconnect() {
    this.debug("Disconnect")
  }

  onChange(event, option) {
    const checked = option.checked

    if (checked) {
      this.reconcile(option)
    }
  }

  reconcile(selectedOption) {
    let options = this.optionTargets.filter(option => option != selectedOption)

    options = options.filter(option => option.checked)

    const exclusiveSelectedOption = "exclusive" in selectedOption.dataset
    if (!exclusiveSelectedOption) {
      options = options.filter(option => "exclusive" in option.dataset)
    }

    options.forEach(option => {
      this.debug("Unchecking option", { nameAttribute: option.name })

      option.checked = false

      const event = new Event("change", { bubbles: true })
      option.dispatchEvent(event)
    })
  }

  debug(message, data) {
    Log.debug("Option Group - " + message, data)
  }
}
